<template>
	<div>
		<div class="form-control-static">{{ c_value }}</div>
		<div class="ctrl-extraDescr" v-if="c_ctrlParams.extraDescr" v-html="c_ctrlParams.extraDescr"></div>
	</div>
</template>

<script>
/**
		Контрол для пользовательских АРМ, пишет в БД логин или IP пользователя, либо null если пользователь не аутентифицирован.
		При просмотре работает как static.
		https://jira.oooinex.ru/browse/PIRS2018-461
	*/
import ctrlMixins from './_mixins.js';
import { ctrlParamsForAll } from './_common-stuff.ts';

export default {
	name: 'ctrl_userData',
	meta: {
		// это наши данные, т.е. вуй при объявлении компонента их не использует
		title: 'Пользователь (логин/email/IP)',
		params: {
			userDataType: {
				name: 'Данные для записи',
				editType: 'select',
				options: [
					{
						id: 'IP',
						name: 'IP',
					},
					{
						id: 'LOGIN',
						name: 'Логин',
					},
					{
						id: 'EMAIL',
						name: 'Email',
					},
				],
			},
			bDisplayValue: {
				name: 'Отображать значение',
				editType: 'checkbox',
			},
			...ctrlParamsForAll,
		},
	},
	mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
	props: {
		// большая часть пропсов приезжает из ctrlMixins!
		value: {
			default: null,
		},
	},
	data: function () {
		return {};
	},
};
</script>
